var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"navbar-item",attrs:{"exact":true,"active-class":'active',"to":'/categories/' + _vm.item.slug}},[_c('p',{staticClass:"item-name"},[_vm._v(_vm._s(_vm.item.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }